"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ParentPanel = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _enums = require("./enums");
var _reactMintl = require("@godaddy/react-mintl");
var _golfToEid = _interopRequireDefault(require("@gd-internal/golf-to-eid"));
var _link = _interopRequireDefault(require("@ux/link"));
var _linkArrow = _interopRequireDefault(require("@ux/icon/link-arrow"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
class ParentPanel extends _react.Component {
  constructor() {
    super(...arguments);
    this.renderParents = this.renderParents.bind(this);
    this.focusables = [];
    this.state = _objectSpread(_objectSpread({}, this.state), {}, {
      hovered: false
    });
    this.createFocusRefs = this.createFocusRefs.bind(this);
    this.focusNext = this.focusNext.bind(this);
    this.focusPrevious = this.focusPrevious.bind(this);
  }

  /**
   * Focus on the next link in the shown panel or move focus to close button when appropriate
   * @private
   */
  focusNext() {
    if (this.focusables.length < 1) return;
    if (1 + this.focusables.indexOf(document.activeElement) === this.focusables.length) {
      this.props.setFocusToClose();
    } else {
      const newIndex = (1 + this.focusables.indexOf(document.activeElement)) % this.focusables.length;
      this.focusables[newIndex].focus();
    }
  }

  /**
   * Focus on the previous link in the shown panel or move focus to close button when appropriate
   * @private
   */
  focusPrevious() {
    const len = this.focusables.length;
    if (this.focusables.indexOf(document.activeElement) === 0) {
      this.props.setFocusToClose();
    } else if (this.focusables.indexOf(document.activeElement) < 0 /* -1 == not found */) {
      const newIndex = len - 1;
      this.focusables[newIndex].focus();
    } else {
      const newIndex = (len - 1 + this.focusables.indexOf(document.activeElement)) % len;
      this.focusables[newIndex].focus();
    }
  }

  /**
   * Store refs to the first and last focusable nav items
   * @private
   * @param {HTMLElement} btn DOM node to be stored in ref
   */
  createFocusRefs(btn) {
    this.focusables.push(btn);
  }

  /**
   * Render top level headings for nav. If the nav has children,
   * the heading will trigger expansion of child panel
   *
   * @private
   * @param {Object[]} nav Array of objects for generating parent items
   * @returns {React.ReactElement[]} List items for parent nav items
   */
  renderParents(nav) {
    const props = this.props;
    return nav.map(item => {
      if (item.onlyallproducts) {
        return;
      }
      const {
        children,
        title,
        href,
        id
      } = item;
      if (title) {
        const eid = (0, _golfToEid.default)(id, {
          prefix: props.eidPrefix,
          postfix: 'link.click'
        });
        if (children && children.length > 0) {
          // list item that will trigger a menu
          return /*#__PURE__*/_react.default.createElement("li", {
            className: "parent-with-child",
            key: id,
            "data-eid": eid
          }, /*#__PURE__*/_react.default.createElement("button", {
            tabIndex: props.tabIndex,
            onClick: () => props.onParentClick(item),
            onMouseEnter: () => this.setState({
              hovered: true
            }),
            onMouseLeave: () => this.setState({
              hovered: false
            }),
            ref: this.createFocusRefs
          }, /*#__PURE__*/_react.default.createElement("span", null, title), /*#__PURE__*/_react.default.createElement(_linkArrow.default, {
            "aria-hidden": "true",
            className: "arrow-position"
          })));
        } else if (href) {
          // Plain link
          return /*#__PURE__*/_react.default.createElement("li", {
            key: id
          }, /*#__PURE__*/_react.default.createElement(_link.default, {
            href: href,
            "data-eid": eid,
            urlArgs: this.props.urlArgs,
            onClicked: props.onClose,
            className: "single-parent-link",
            tabIndex: props.tabIndex,
            onMouseEnter: () => this.setState({
              hovered: true
            }),
            onMouseLeave: () => this.setState({
              hovered: false
            })
          }, /*#__PURE__*/_react.default.createElement("span", null, title)));
        }
      }
    });
  }
  render() {
    const {
      props,
      state
    } = this;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('parent-menu-panel', {
        'open': props.open,
        'product-flyout-hovered-menu': props.open && state.hovered
      })
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "menu-scroller",
      onScroll: this.props.onScroll,
      ref: r => {
        this.outerDiv = r;
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "parent-navigation",
      ref: r => {
        this.innerDiv = r;
      }
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: "product-flyout-heading",
      role: "heading",
      "aria-level": "2"
    }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: _enums.golf.product
    })), /*#__PURE__*/_react.default.createElement("ul", {
      className: "parent-link-items parent-product-nav"
    }, this.renderParents(props.productNav))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: "product-flyout-heading",
      role: "heading",
      "aria-level": "2"
    }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: _enums.golf.discover
    })), /*#__PURE__*/_react.default.createElement("ul", {
      className: "parent-link-items parent-discover-nav"
    }, this.renderParents(props.discoverNav))))));
  }
}
exports.ParentPanel = ParentPanel;
ParentPanel.propTypes = {
  productNav: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  discoverNav: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  onClose: _propTypes.default.func,
  onParentClick: _propTypes.default.func,
  open: _propTypes.default.bool,
  tabIndex: _propTypes.default.number,
  eidPrefix: _propTypes.default.string,
  urlArgs: _propTypes.default.object,
  onScroll: _propTypes.default.func,
  setFocusToClose: _propTypes.default.func
};
ParentPanel.defaultProps = {
  onParentClick: () => {},
  open: false
};
var _default = ParentPanel;
exports.default = _default;